import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { AlineacionImagenEnum } from "@componentes/Enums.enum";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
    {
        selector: 'consultaacuerdo_general',
        templateUrl: './consultaacuerdo_general.component.html',
        styleUrls: ['./consultaacuerdo_acuerdo.component.scss']
    })

export class ConsultaAcuerdoGeneralComponent implements AfterViewInit{
  @Input() entidad!: any;
  @Input() accion!: {accionid: number, accion: string};
  @Output() output = new EventEmitter();
  consulta!: boolean;
  buscarcompetencia: boolean = false;
  buscarcriterio: boolean = false;

  listageneral:any[] = [];
  periodo:any;
  listaobservacion: any[] = [];
  listapuesto: any[] = [];
  puesto:number = 0;
  puestolocal: number = 0;
  tipovisualizacion: number = 0;

  entidadbusqueda: any;

  entidadacuerdo:any;

  public AlineacionImagenEnum = AlineacionImagenEnum;
  constructor(private cdr: ChangeDetectorRef,private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
      this.tipovisualizacion = 1;
      this.puestolocal = this.entidad.puestoid;
      this.periodo = {
        "periodoevaluacionid":this.entidad.periodoevaluacionid,
        "cicloid":this.entidad.cicloid,
      }
      this.entidadbusqueda = {
        "colaboradorid": this.entidad.colaboradorsubordinadoid,
        "puestoid": this.entidad.puestosubid
      }
    }

    VerPorCompetencia(event:any){
      this.listageneral = [];
      if(event){
        this.buscarcriterio = false;
        if(this.entidad.asignacionacuerdoresponsableid){
          if(this.puesto){
            this.tipovisualizacion = 3;
            this.CargarInfo(3);
          }else{
            this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
          }
        }else{
          this.buscarcriterio = false;
          this.tipovisualizacion = 3;
          this.CargarInfo(3);
        }
      }else{
        if(this.entidad.asignacionacuerdoresponsableid){
          if(this.puesto){
            this.tipovisualizacion = 1;
            this.CargarInfo(1);
          }else{
            this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
          }
        }else{
          this.tipovisualizacion = 1;
          this.CargarInfo(1);
        }

      }
      this.cdr.detectChanges();
  }

  VerPorCriterio(event:any){
      this.listageneral = [];
      if (this.requieresPuesto()) {
        if (!this.puesto) {
          this.mensajeService.Alerta(
            AlertaEnum.Warning,
            "No se tienen seleccionado ningun puesto para visualizar resultados"
          );
          return;
        }
      }

      this.estatusvisualizacion(event);

      this.CargarInfo(this.tipovisualizacion);
      this.cdr.detectChanges();
  }

  private requieresPuesto(): boolean {
    return Boolean(this.entidad?.asignacionacuerdoresponsableid);
  }

  private estatusvisualizacion(event: boolean): void {
    this.tipovisualizacion = event ? 2 : 1;
    if (event) {
      this.buscarcompetencia = false;
    }
  }

  CargarInfo(tipovisualizar: number){
      this.appService.Post("reporte/evaluacion/preguntageneral",{"puestolocal": this.puestolocal ,"general":this.entidadbusqueda, "periodo": this.periodo, "agrupar":tipovisualizar}).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              this.listageneral = res.data.datos;
              this.listaobservacion = res.data.observaciones;
              if(this.listageneral.length == 0 ){
                  this.mensajeService.Alerta(AlertaEnum.Warning, "No se encontró evaluaciones")
              }else{
                  this.listageneral.map((competencia: any) => {
                      competencia.colortext = this.cambiarcolor(competencia.color);
                  })
              }
              this.cdr.detectChanges();

          }
      })
  }

  cambiarcolor(color: any): string {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
      let val: any = [];
      if (result) {
          let r = parseInt(result[1], 16)
          let g = parseInt(result[2], 16)
          let b = parseInt(result[3], 16)
          val = this.rgbToHsl(r, g, b);
      }
      if (val[2] < 50) {
          return "colorblanco"
      } else {

          return "colornegro";
      }
  }

  rgbToHsl(r: any, g: any, b: any) {
      r /= 255;
      g /= 255;
      b /= 255;

      // Find greatest and smallest channel values
      let cmin = Math.min(r, g, b),
          cmax = Math.max(r, g, b),
          delta = cmax - cmin,
          h = 0,
          s = 0,
          l = 0;

      // Calculate hue
      // No difference
      if (delta == 0)
          h = 0;
      // Red is max
      else if (cmax == r)
          h = ((g - b) / delta) % 6;
      // Green is max
      else if (cmax == g)
          h = (b - r) / delta + 2;
      // Blue is max
      else
          h = (r - g) / delta + 4;

      h = Math.round(h * 60);

      // Make negative hues positive behind 360°
      if (h < 0)
          h += 360;

      // Calculate lightness
      l = (cmax + cmin) / 2;

      // Calculate saturation
      s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

      // Multiply l and s by 100
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);

      return [h, s, l];
  }

  buscardatos(data:any){
    if(data){
      this.entidadbusqueda.puestoid = data;
      this.puestolocal = data;
      this.CargarInfo(1);
    }else{
      this.listageneral = [];
      this.listaobservacion = [];
    }
  }
    Salir(){
      this.output.next();
    }
  }
